module.exports = __webpack_public_path__ + "media/images/photos-btn-33880656f413aad77989216c00b3a910c020582d39517447d9ba545f69a140e1.svg";